if (!customElements.get('supplements-toggle')) {
  class SupplementsToggle extends HTMLElement {
    constructor() {
      super();
    }

    handleClick(event) {
      event.preventDefault();

      document.dispatchEvent(new CustomEvent('supplements-modal:toggle'));
    }

    connectedCallback() {
      this.addEventListener('click', this.handleClick.bind(this));
    }
  }

  customElements.define('supplements-toggle', SupplementsToggle);
}